import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const DetailItem = ({ label, value, icon, color }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 1.2,
    }}
  >
    <Stack direction="row" spacing={1} alignItems="center">
      {icon &&
        React.cloneElement(icon, {
          sx: { color: '#A3AED0', fontSize: '18px' },
        })}
      <Typography sx={{ color: '#A3AED0', fontSize: '14px', fontWeight: 500 }}>
        {label}
      </Typography>
    </Stack>
    <Typography
      sx={{
        color: color || '#2B3674',
        fontSize: '14px',
        fontWeight: 700,
        textAlign: 'right',
        ml: 2,
      }}
    >
      {value || '—'}
    </Typography>
  </Box>
);

export default DetailItem;
